// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_EBr","cls2":"Header-cls2_3Jb Header-cls1_EBr"};